module.exports = __webpack_public_path__ + "static/media/joelhofrangocatupiry.b254fa7c.webp";